import React, { useState, useRef, useEffect, useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import WizardHat from './WizardHat';
import LeaveCalendar from './LeaveCalendar';
import './App.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// ===== WYZCON SVG ICON LIBRARY =====
const W = {
  hat: (size = 20, color = '#fff') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2L8.5 14H4L3 18h18l-1-4h-4.5L12 2z" fill={color} opacity="0.9"/>
      <path d="M3 18l0.5 2c0.2 0.8 0.8 1.2 1.5 1.2h14c0.7 0 1.3-0.4 1.5-1.2L21 18H3z" fill={color} opacity="0.6"/>
      <path d="M12 2l1.2 4.5" stroke="#21d4fd" strokeWidth="1.2" strokeLinecap="round" opacity="0.8"/>
      <circle cx="14" cy="5" r="0.8" fill="#21d4fd" opacity="0.9"/>
      <circle cx="10" cy="8" r="0.6" fill="#21d4fd" opacity="0.7"/>
      <circle cx="15" cy="9" r="0.5" fill="#f59e0b" opacity="0.8"/>
    </svg>
  ),
  send: (size = 20, color = '#fff') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
    </svg>
  ),
  plus: (size = 16, color = '#21d4fd') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  ),
  menu: (size = 22, color = 'currentColor') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
      <line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  ),
  source: (size = 14, color = '#21d4fd') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
    </svg>
  ),
  globe: (size = 14, color = '#10b981') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  ),
  user: (size = 16, color = '#fff') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
    </svg>
  ),
  trash: (size = 14, color = 'currentColor') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
      <path d="M10 11v6"/><path d="M14 11v6"/>
    </svg>
  ),
  calendar: (size = 16, color = '#7c3aed') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  ),
  dollar: (size = 16, color = '#10b981') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
  ),
  fileEdit: (size = 16, color = '#f59e0b') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
    </svg>
  ),
  building: (size = 16, color = '#2152ff') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2"/><line x1="9" y1="6" x2="9" y2="6.01"/><line x1="15" y1="6" x2="15" y2="6.01"/>
      <line x1="9" y1="10" x2="9" y2="10.01"/><line x1="15" y1="10" x2="15" y2="10.01"/>
      <line x1="9" y1="14" x2="9" y2="14.01"/><line x1="15" y1="14" x2="15" y2="14.01"/>
      <path d="M9 22v-4h6v4"/>
    </svg>
  ),
  book: (size = 16, color = '#21d4fd') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
    </svg>
  ),
  heart: (size = 16, color = '#ef4444') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
    </svg>
  ),
  alertTriangle: (size = 14, color = '#f59e0b') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  ),
  flag: (size = 14, color = '#ef4444') => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/>
    </svg>
  ),
};


function App() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [conversationId, setConversationId] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [showSidebar, setShowSidebar] = useState(false);
  const [showSources, setShowSources] = useState(null);
  const [fingerprint, setFingerprint] = useState(null);
  const [fpReady, setFpReady] = useState(false);
  const [correctionMode, setCorrectionMode] = useState(null);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  // ── Fingerprint ──────────────────────────────────
  useEffect(() => {
    const init = async () => {
      try {
        const cached = localStorage.getItem('_wyzcon_fp');
        if (cached) { setFingerprint(cached); setFpReady(true); return; }
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        localStorage.setItem('_wyzcon_fp', result.visitorId);
        setFingerprint(result.visitorId);
        setFpReady(true);
      } catch (err) {
        let fb = localStorage.getItem('_wyzcon_fp');
        if (!fb) { fb = 'fb_' + crypto.randomUUID(); localStorage.setItem('_wyzcon_fp', fb); }
        setFingerprint(fb);
        setFpReady(true);
      }
    };
    init();
  }, []);

  const scrollToBottom = () => messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  useEffect(() => { scrollToBottom(); }, [messages]);

  const loadConversations = useCallback(async () => {
    if (!fingerprint) return;
    try {
      const res = await fetch(`${API}/api/conversations/?fingerprint=${encodeURIComponent(fingerprint)}`);
      setConversations(await res.json());
    } catch (err) { console.error('Failed to load conversations:', err); }
  }, [fingerprint]);

  useEffect(() => { if (fpReady) loadConversations(); }, [fpReady, loadConversations]);

  const loadConversation = async (id) => {
    try {
      const res = await fetch(`${API}/api/conversations/${id}/?fingerprint=${encodeURIComponent(fingerprint)}`);
      if (!res.ok) return;
      const data = await res.json();
      setConversationId(id);
      setMessages(data.messages.map(m => ({
        role: m.role,
        content: m.content,
        sources: m.sources || [],
        widget: m.widget || null,
      })));
      setShowSidebar(false);
      setCorrectionMode(null);
    } catch (err) { console.error('Failed to load conversation:', err); }
  };

  const newChat = () => { setConversationId(null); setMessages([]); setShowSidebar(false); setCorrectionMode(null); inputRef.current?.focus(); };

  // ── Send Message ──────────────────────────────────
  const sendMessage = async (e) => {
    e.preventDefault();
    if (!input.trim() || loading || !fingerprint) return;
    const userMessage = input.trim();
    setInput('');
    setMessages(prev => [...prev, { role: 'user', content: userMessage }]);
    setLoading(true);
    setCorrectionMode(null);

    try {
      const res = await fetch(`${API}/api/chat/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: userMessage,
          conversation_id: conversationId,
          fingerprint,
          visitor_metadata: {
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            language: navigator.language,
            screen: `${screen.width}x${screen.height}`,
          },
        }),
      });
      const data = await res.json();
      if (!conversationId && data.conversation_id) setConversationId(data.conversation_id);

      const newMsg = {
        role: 'assistant',
        content: data.answer,
        sources: data.sources || [],
        webSources: data.web_sources || [],
        usedWebSearch: data.used_web_search || false,
        usedVerifiedCache: data.used_verified_cache || false,
        widget: data.widget || null,
        confidence: data.confidence || null,
        messageId: data.message_id || null,
      };

      const newIndex = messages.length + 1;
      setMessages(prev => [...prev, newMsg]);

      // If correction was detected, show correction source panel
      if (data.correction_detected && data.correction_sources) {
        setCorrectionMode({
          messageIndex: newIndex,
          sources: data.correction_sources,
          originalQuery: data.original_query,
        });
      }

      loadConversations();
    } catch {
      setMessages(prev => [...prev, { role: 'assistant', content: 'Sorry, I had trouble connecting. Please try again.', sources: [] }]);
    }
    setLoading(false);
  };

  // ── Report Correction (manual flag button) ──
  const reportCorrection = async (messageIndex) => {
    const assistantMsg = messages[messageIndex];
    let originalQuery = '';
    for (let i = messageIndex - 1; i >= 0; i--) {
      if (messages[i].role === 'user') {
        originalQuery = messages[i].content;
        break;
      }
    }

    try {
      const res = await fetch(`${API}/api/correction/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          conversation_id: conversationId,
          message_id: assistantMsg.messageId,
          original_query: originalQuery,
          user_correction: '',
          fingerprint,
        }),
      });
      const data = await res.json();

      setCorrectionMode({
        messageIndex,
        sources: data.suggested_sources || [],
        webSources: data.web_sources || [],
        webAnswer: data.web_answer || '',
        correctionId: data.correction_id,
        originalQuery,
        loading: false,
      });
    } catch (err) { console.error('Failed to report correction:', err); }
  };

  const selectCorrectionSource = async (source, sourceType = 'local') => {
    if (!correctionMode?.correctionId) {
      setCorrectionMode(null);
      return;
    }

    try {
      await fetch(`${API}/api/correction/select/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          correction_id: correctionMode.correctionId,
          selected_source: source,
          source_type: sourceType,
          fingerprint,
        }),
      });
      setCorrectionMode(null);
    } catch (err) { console.error('Failed to select source:', err); }
  };

  const deleteConversation = async (id, e) => {
    e.stopPropagation();
    try {
      await fetch(`${API}/api/conversations/${id}/?fingerprint=${encodeURIComponent(fingerprint)}`, { method: 'DELETE' });
      if (conversationId === id) newChat();
      loadConversations();
    } catch (err) { console.error('Delete failed:', err); }
  };

  const suggestedQuestions = [
    "Can my principal force me to cover a class during my prep?",
    "How many observations can I receive per year?",
    "What is the grievance process and timeline?",
    "How much is the retention bonus in 2026?",
    "What are my rights regarding the workday schedule?",
    "Can I be required to work during my lunch period?",
  ];

  const topics = [
    { icon: W.calendar(15, '#7c3aed'), label: 'Workday & Schedule' },
    { icon: W.dollar(15, '#10b981'),   label: 'Salary & Benefits' },
    { icon: W.fileEdit(15, '#f59e0b'), label: 'Grievances' },
    { icon: W.building(15, '#2152ff'), label: 'Working Conditions' },
    { icon: W.book(15, '#21d4fd'),     label: 'Professional Dev' },
    { icon: W.heart(15, '#ef4444'),    label: 'Leaves & Absences' },
  ];

  // ── Init screen ──────────────────────────────────
  if (!fpReady) {
    return (
      <div className="init-screen">
        <div className="init-content">
          <div className="init-hat">{W.hat(36, '#fff')}</div>
          <div className="init-brand">Wyzcon</div>
          <p>Initializing…</p>
          <div className="loading-dots" style={{ justifyContent: 'center', marginTop: 12, background: 'none' }}>
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      {/* ── SIDEBAR ── */}
      <div className={`sidebar ${showSidebar ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <div className="brand-icon">{W.hat(18, '#fff')}</div>
            <h2>Chats</h2>
          </div>
          <button className="new-chat-btn" onClick={newChat}>{W.plus(14, '#21d4fd')} New</button>
        </div>

        <div className="conversation-list">
          {conversations.map(c => (
            <div key={c.id} className={`conversation-item ${conversationId === c.id ? 'active' : ''}`} onClick={() => loadConversation(c.id)}>
              <span className="convo-title">{c.title || 'New Conversation'}</span>
              <button className="delete-btn" onClick={(e) => deleteConversation(c.id, e)} title="Delete">{W.trash(13, 'currentColor')}</button>
            </div>
          ))}
          {conversations.length === 0 && <p className="no-convos">No conversations yet</p>}
        </div>

        <div className="sidebar-footer">
          <span>Powered by</span>
          <span className="wyzcon-mark">Wyzcon</span>
        </div>
      </div>

      {/* ── MAIN ── */}
      <div className="main">
        <header className="header">
          <button className="menu-btn" onClick={() => setShowSidebar(!showSidebar)}>{W.menu(22)}</button>
          <div className="header-icon">{W.hat(22, '#fff')}</div>
          <div className="header-title">
            <h1>UFT Contract Assistant</h1>
            <p>Know your rights — powered by Wyzcon AI</p>
          </div>
          <span className="header-badge">BETA</span>
        </header>

        <div className="messages">
          {messages.length === 0 && (
            <div className="welcome">
              <div className="welcome-hat-3d">
                <WizardHat
                  canvasStyle={{ width: '100%', height: '100%', borderRadius: 20 }}
                  style={{ width: '100%', height: '100%' }}
                />
              </div>

              <h2>
                UFT Contract <span className="highlight">Assistant</span>
              </h2>
              <p>Ask questions about your UFT-DOE contract rights. I've read the whole thing so you don't have to.</p>

              <div className="topics">
                {topics.map((t, i) => (
                  <span key={i} className="topic-pill">
                    <span className="topic-icon">{t.icon}</span>
                    {t.label}
                  </span>
                ))}
              </div>

              <div className="suggested">
                <p className="suggested-label">Try asking</p>
                {suggestedQuestions.map((q, i) => (
                  <button key={i} className="suggested-btn" onClick={() => { setInput(q); inputRef.current?.focus(); }}>{q}</button>
                ))}
              </div>
            </div>
          )}

          {messages.map((msg, i) => (
            <div key={i} className={`message ${msg.role}`}>
              <div className="message-avatar">
                {msg.role === 'user' ? W.user(16, '#fff') : W.hat(18, '#fff')}
              </div>
              <div className="message-content">
                <ReactMarkdown>{msg.content}</ReactMarkdown>

                {/* ── CONFIDENCE BANNER — invites user to help ── */}
                {msg.role === 'assistant' && msg.confidence && msg.confidence.level === 'low' && !msg.usedWebSearch && (
                  <div className="confidence-banner low">
                    <div className="confidence-banner-text">
                      {W.alertTriangle(14, '#f59e0b')}
                      <span>I'm not very confident in this answer — my sources may not fully cover this.</span>
                    </div>
                    <button
                      className="confidence-help-btn"
                      onClick={() => reportCorrection(i)}
                    >
                      🔍 Help me find the right source
                    </button>
                  </div>
                )}

                {msg.role === 'assistant' && msg.confidence && msg.confidence.level === 'medium' && (
                  <div className="confidence-banner medium">
                    <div className="confidence-banner-text">
                      {W.alertTriangle(14, '#3b82f6')}
                      <span>I found some info on this but it might not be complete.</span>
                    </div>
                    <button
                      className="confidence-help-btn medium"
                      onClick={() => reportCorrection(i)}
                    >
                      Something wrong? Help me improve
                    </button>
                  </div>
                )}

                {/* ── VERIFIED CACHE BADGE (learned answer) ── */}
                {msg.role === 'assistant' && msg.usedVerifiedCache && (
                  <div className="verified-cache-badge">
                    ✅ <span>Learned answer — verified from a previous correction</span>
                  </div>
                )}

                {/* ── WEB SEARCH BADGE ── */}
                {msg.role === 'assistant' && msg.usedWebSearch && (
                  <div className="web-search-badge">
                    {W.globe(14, '#10b981')}
                    <span>Verified via web search — checked official UFT &amp; DOE sources</span>
                  </div>
                )}

                {/* ── INLINE CALENDAR WIDGET ── */}
                {msg.widget && (
                  <LeaveCalendar widget={msg.widget} />
                )}

                {/* ── LOCAL SOURCES + FLAG BUTTON ── */}
                {msg.role === 'assistant' && msg.sources && msg.sources.length > 0 && (
                  <div className="sources-section">
                    <div className="sources-actions">
                      <button className="sources-toggle" onClick={() => setShowSources(showSources === i ? null : i)}>
                        {W.source(14, '#21d4fd')}{' '}
                        {msg.sources.length} source{msg.sources.length > 1 ? 's' : ''} cited
                        {' '}{showSources === i ? '▲' : '▼'}
                      </button>
                      <button
                        className="flag-btn"
                        onClick={() => reportCorrection(i)}
                        title="Report incorrect answer"
                      >
                        {W.flag(14, '#ef4444')} Report
                      </button>
                    </div>
                    {showSources === i && (
                      <div className="sources-list">
                        {msg.sources.map((s, j) => (
                          <div key={j} className="source-item">
                            <div className="source-header">
                              <strong>{s.document}</strong>
                              <span className="source-page">pg. {s.page}</span>
                              <span className={`relevance ${s.relevance > 0.7 ? 'high' : s.relevance > 0.5 ? 'med' : 'low'}`}>
                                {Math.round(s.relevance * 100)}%
                              </span>
                            </div>
                            <p className="source-excerpt">{s.excerpt}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* ── WEB SOURCES (from Groq search) ── */}
                {msg.role === 'assistant' && msg.webSources && msg.webSources.length > 0 && (
                  <div className="web-sources-section">
                    <div className="web-sources-header">
                      {W.globe(14, '#10b981')} Web sources
                    </div>
                    <div className="web-sources-list">
                      {msg.webSources.map((ws, j) => (
                        <a
                          key={j}
                          href={ws.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="web-source-link"
                        >
                          <span className="web-source-title">{ws.title}</span>
                          <span className="web-source-url">{ws.url.replace(/^https?:\/\//, '').split('/')[0]}</span>
                        </a>
                      ))}
                    </div>
                  </div>
                )}

                {/* ── CORRECTION SOURCE SUGGESTIONS ── */}
                {correctionMode && correctionMode.messageIndex === i && (
                  <div className="correction-panel">
                    <div className="correction-header">
                      <strong>🔍 Help me find the right answer</strong>
                      <p className="correction-subtext">
                        I searched my documents and the web. Select the source with the correct info.
                      </p>
                    </div>

                    {/* ── LOCAL DOCUMENTS ── */}
                    {correctionMode.sources.length > 0 && (
                      <div className="correction-section">
                        <div className="correction-section-label">
                          {W.source(14, '#21d4fd')} My Documents
                        </div>
                        <div className="correction-sources">
                          {correctionMode.sources.map((src, j) => (
                            <button
                              key={`local-${j}`}
                              className="correction-source-btn"
                              onClick={() => selectCorrectionSource(src, 'local')}
                            >
                              <div className="correction-source-name">
                                {src.document}
                                <span className={`relevance ${src.relevance > 0.7 ? 'high' : src.relevance > 0.5 ? 'med' : 'low'}`}>
                                  {Math.round(src.relevance * 100)}%
                                </span>
                              </div>
                              <div className="correction-source-type">{src.doc_type}</div>
                              <p className="correction-source-excerpt">{src.excerpt?.slice(0, 150)}...</p>
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* ── WEB SEARCH RESULTS ── */}
                    {correctionMode.webSources && correctionMode.webSources.length > 0 && (
                      <div className="correction-section">
                        <div className="correction-section-label web">
                          {W.globe(14, '#10b981')} Found Online
                        </div>
                        <div className="correction-sources">
                          {correctionMode.webSources.map((ws, j) => (
                            <button
                              key={`web-${j}`}
                              className="correction-source-btn web-source"
                              onClick={() => selectCorrectionSource(ws, 'web')}
                            >
                              <div className="correction-source-name">
                                {ws.title}
                                <span className="relevance high">WEB</span>
                              </div>
                              <div className="correction-source-type">{ws.url.replace(/^https?:\/\//, '').split('/')[0]}</div>
                            </button>
                          ))}
                        </div>

                        {/* Show web search answer preview */}
                        {correctionMode.webAnswer && (
                          <div className="web-answer-preview">
                            <strong>What the web says:</strong>
                            <p>{correctionMode.webAnswer.slice(0, 300)}...</p>
                          </div>
                        )}
                      </div>
                    )}

                    {/* No results at all */}
                    {(!correctionMode.sources.length && (!correctionMode.webSources || !correctionMode.webSources.length)) && (
                      <p className="correction-subtext" style={{ textAlign: 'center', padding: '12px 0' }}>
                        No matching sources found. Try rephrasing your question.
                      </p>
                    )}

                    <button
                      className="correction-dismiss"
                      onClick={() => setCorrectionMode(null)}
                    >
                      None of these — dismiss
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}

          {loading && (
            <div className="message assistant">
              <div className="message-avatar">{W.hat(18, '#fff')}</div>
              <div className="message-content loading-dots"><span></span><span></span><span></span></div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>

        <form className="input-area" onSubmit={sendMessage}>
          <div className="input-wrapper">
            <input ref={inputRef} type="text" value={input} onChange={(e) => setInput(e.target.value)} placeholder="Ask about your UFT contract rights…" disabled={loading} />
            <button type="submit" disabled={loading || !input.trim()}>
              {loading ? <span style={{ fontSize: 14 }}>…</span> : W.send(18, '#fff')}
            </button>
          </div>
          <p className="disclaimer">
            {W.alertTriangle(12, '#f59e0b')} AI assistant — not legal advice. For formal grievances, consult your UFT chapter leader. Powered by Wyzcon.
          </p>
          <p className="disclaimer disclosure">
            This tool is not affiliated with, endorsed by, or sponsored by the United Federation of Teachers (UFT). It is an independent educational resource built by Wyzcon.
          </p>
        </form>
      </div>

      {showSidebar && <div className="overlay" onClick={() => setShowSidebar(false)} />}
    </div>
  );
}

export default App;
